<template>
  <section id="reports">
    <div class="mb-2">
      <mdb-btn color="primary" @click.native="downloadServices()">
        Download Services Report
      </mdb-btn>
    </div>
    <mdb-card>
      <mdb-card-body>
        <div class="farm-filter">
          <label>Filter Farms</label>
          <multiselect
            v-model="selectedFarms"
            placeholder="Select farms to show"
            label="name"
            track-by="id"
            :options="farmRecords"
            :multiple="true"
            :taggable="true"
            @input="farmSelected"
          />
        </div>
        <div class="custom-control custom-switch">
          <input
            id="doneSwitch"
            type="checkbox"
            class="custom-control-input"
            @click="toggleIsDone"
          />
          <label class="custom-control-label" for="doneSwitch">Show Past Services</label>
        </div>
      </mdb-card-body>
    </mdb-card>
    <Table :headers="servicesTableHeaders" :title="tableTitle">
      <tbody slot="rows">
        <tr v-for="(service, index) in services" :key="index">
          <td @click="setServiceDone(service)">
            <input v-model="service.isDone" type="checkbox" />#{{
              service.reference
            }}
          </td>
          <td>{{ service.farmName }}</td>
          <td>{{ service.fieldName }}</td>
          <td>{{ service.servicesSummary }}</td>
          <td>{{ service.equipmentSummary }}</td>
          <td>{{ service.notes }}</td>
          <td>{{ service.startDatetime | dateFormat }}</td>
          <td>{{ service.endDatetime | dateFormat }}</td>
        </tr>
      </tbody>
    </Table>
  </section>
</template>

<script>
import moment from "moment";
import { mdbBtn, mdbCard, mdbCardBody } from "mdbvue";
import Multiselect from "vue-multiselect";
import Table from "@/components/Table";
import { farmsModel } from "../models/farm";
import { fieldsModel } from "../models/field";
import { reportService } from "../services/reports.service";

export default {
  name: "Reports",
  components: {
    Table,
    mdbBtn,
    Multiselect,
    mdbCard,
    mdbCardBody
  },
  data() {
    return {
      tableTitle: 'Showing Pending Services',
      showDoneServices: false,
      selectedFarms: [],
      farmRecords: [],
      services: [],
      pendingServices: [],
      doneServices: [],
      servicesTableHeaders: [
        "Service #",
        "Farm",
        "Field No.",
        "Services",
        "Equipment",
        "Notes",
        "Start Date",
        "End Date"
      ]
    };
  },
  beforeMount() {
    this.getAllFieldServices();
    this.getFarms();
  },
  methods: {
    getAllFieldServices() {
      const filteredFarms = this.getFarmIdFilter();
      let query = [];
      if (filteredFarms.length) {
        query = ["farmId", "in", filteredFarms];
      }
      this.services = [];
      this.doneServices = [];
      this.pendingServices = [];
      return fieldsModel.list("name", ...query).then(fields => {
        const services = fieldsModel.getAllFieldServices(fields);
        this.partitionServices(services);
      });
    },
    downloadServices() {
      const date = new Date();
      const today = moment(date).format("YYYY-MM-DD");
      const name = `services-${today}.csv`;
      const headers = [
        [
          "Service #",
          "Farm",
          "Field No.",
          "Services",
          "Equipment",
          "Start Date",
          "End Date",
          "Notes",
          "Employees"
        ]
      ];
      const data = this.services.map(service => {
        return [
          service.reference,
          service.farmName,
          service.fieldName,
          service.servicesSummary,
          service.equipmentSummary,
          service.startDatetime,
          service.endDatetime,
          service.notes,
          service.employees
        ];
      });
      const report = headers.concat(data);
      reportService.exportToCsv(name, report);
    },
    getFarms() {
      return farmsModel.list("name").then(farms => (this.farmRecords = farms));
    },
    farmSelected() {
      this.getAllFieldServices();
    },
    getFarmIdFilter() {
      const farmIds = this.selectedFarms.map(farm => farm.id);
      return farmIds;
    },
    setServiceDone(service) {
      console.log("pending", service);
      service.isDone = !service.isDone || false;
      console.log("active", service.isDone);
      return fieldsModel
        .updateService(service.fieldId, service.id, service)
        .then(() => this.getAllFieldServices());
    },
    setServices() {
      if (this.showDoneServices) {
        this.tableTitle = 'Showing Past Services';
        this.services = this.doneServices;
      } else {
        this.tableTitle = 'Showing Pending Services';
        this.services = this.pendingServices;
      }
    },
    partitionServices(services) {
      services.forEach(service => {
        if (service.isDone) {
          this.doneServices.push(service);
        } else {
          this.pendingServices.push(service);
        }
      });
      this.setServices();
    },
    toggleIsDone() {
      this.showDoneServices = !this.showDoneServices;
      this.setServices();
    }
  }
};
</script>
<style scoped>
input[type="checkbox"] {
  margin-right: 0.3rem;
  height: unset;
}

.farm-filter {
  margin-bottom: 1rem;
}
</style>
